/**
 * DataSourceNotConnected — full card replacement for NOT_CONNECTED metrics
 *
 * Shows: lock icon, integration label, description, and CTA.
 * Replaces the card body entirely — never shows fake values.
 */
import React from 'react';
import { FiLock } from 'react-icons/fi';
import type { NotConnectedInfo } from '../../../types/insightsTypes';

interface DataSourceNotConnectedProps {
  info: NotConnectedInfo;
  /** Metric display name for context */
  metricName?: string;
  /** If true, renders as a compact inline block instead of a full card */
  inline?: boolean;
}

const DataSourceNotConnected: React.FC<DataSourceNotConnectedProps> = ({
  info,
  metricName,
  inline = false,
}) => {
  if (inline) {
    return (
      <div className="flex items-center gap-2 text-slate-400 py-1">
        <FiLock size={14} />
        <span className="text-xs font-medium">{info.label}</span>
      </div>
    );
  }

  return (
    <div className="bg-slate-50 rounded-lg border border-slate-200 p-4 sm:p-6 flex flex-col items-center justify-center text-center min-h-[120px]">
      <div className="bg-slate-200 p-3 rounded-full mb-3">
        <FiLock className="text-slate-500" size={20} />
      </div>
      {metricName && (
        <p className="text-sm font-medium text-slate-600 mb-1">{metricName}</p>
      )}
      <p className="text-sm font-semibold text-slate-700 mb-1">{info.label}</p>
      <p className="text-xs text-slate-500 max-w-xs">{info.description}</p>
    </div>
  );
};

export default DataSourceNotConnected;
